// Generated by purs version 0.15.15
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var PathCommand = function (x) {
    return x;
};
var Sweep0 = /* #__PURE__ */ (function () {
    function Sweep0() {

    };
    Sweep0.value = new Sweep0();
    return Sweep0;
})();
var Sweep1 = /* #__PURE__ */ (function () {
    function Sweep1() {

    };
    Sweep1.value = new Sweep1();
    return Sweep1;
})();
var Rel = /* #__PURE__ */ (function () {
    function Rel() {

    };
    Rel.value = new Rel();
    return Rel;
})();
var Abs = /* #__PURE__ */ (function () {
    function Abs() {

    };
    Abs.value = new Abs();
    return Abs;
})();
var Arc0 = /* #__PURE__ */ (function () {
    function Arc0() {

    };
    Arc0.value = new Arc0();
    return Arc0;
})();
var Arc1 = /* #__PURE__ */ (function () {
    function Arc1() {

    };
    Arc1.value = new Arc1();
    return Arc1;
})();
var z = "z";
var toArrayString = /* #__PURE__ */ Safe_Coerce.coerce();
var showCommandSweepChoice = {
    show: function (v1) {
        if (v1 instanceof Sweep0) {
            return "Sweep0";
        };
        if (v1 instanceof Sweep1) {
            return "Sweep1";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 70, column 10 - line 72, column 23): " + [ v1.constructor.name ]);
    }
};
var showCommandPositionReference = {
    show: function (v1) {
        if (v1 instanceof Abs) {
            return "Abs";
        };
        if (v1 instanceof Rel) {
            return "Rel";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 43, column 10 - line 45, column 17): " + [ v1.constructor.name ]);
    }
};
var showCommandArcChoice = {
    show: function (v1) {
        if (v1 instanceof Arc0) {
            return "Arc0";
        };
        if (v1 instanceof Arc1) {
            return "Arc1";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 54, column 10 - line 56, column 19): " + [ v1.constructor.name ]);
    }
};
var renderCommand = function (cmd) {
    return function (s_) {
        if (cmd instanceof Rel) {
            return s_;
        };
        if (cmd instanceof Abs) {
            return Data_String_Common.toUpper(s_);
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 81, column 24 - line 83, column 20): " + [ cmd.constructor.name ]);
    };
};
var renderCommand1Arg = function (s_) {
    return function (ref) {
        return function (a_) {
            return renderCommand(ref)(s_) + show(a_);
        };
    };
};
var v = /* #__PURE__ */ renderCommand1Arg("v");
var renderCommand2Args = function (s_) {
    return function (ref) {
        return function (a_) {
            return function (b) {
                return renderCommand(ref)(s_) + (show(a_) + (", " + show(b)));
            };
        };
    };
};
var t = /* #__PURE__ */ renderCommand2Args("t");
var renderCommand4Args = function (s_) {
    return function (ref) {
        return function (a_) {
            return function (b) {
                return function (c_) {
                    return function (d_) {
                        return renderCommand(ref)(s_) + (show(a_) + (", " + (show(b) + (", " + (show(c_) + (", " + show(d_)))))));
                    };
                };
            };
        };
    };
};
var s = /* #__PURE__ */ renderCommand4Args("s");
var q = /* #__PURE__ */ renderCommand4Args("q");
var printPathCommand = function (v1) {
    return v1;
};
var showPathCommand = {
    show: function (val) {
        return printPathCommand(val);
    }
};
var printCommandSweepChoice = function (v1) {
    if (v1 instanceof Sweep0) {
        return "0";
    };
    if (v1 instanceof Sweep1) {
        return "1";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 75, column 27 - line 77, column 16): " + [ v1.constructor.name ]);
};
var printCommandArcChoice = function (v1) {
    if (v1 instanceof Arc0) {
        return "0";
    };
    if (v1 instanceof Arc1) {
        return "1";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Path (line 59, column 25 - line 61, column 14): " + [ v1.constructor.name ]);
};
var m = /* #__PURE__ */ renderCommand2Args("m");
var l = /* #__PURE__ */ renderCommand2Args("l");
var h = /* #__PURE__ */ renderCommand1Arg("h");
var eqPathCommand = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var eqCommandSweepChoice = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Sweep0 && y instanceof Sweep0) {
                return true;
            };
            if (x instanceof Sweep1 && y instanceof Sweep1) {
                return true;
            };
            return false;
        };
    }
};
var eqCommandPositionReference = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Rel && y instanceof Rel) {
                return true;
            };
            if (x instanceof Abs && y instanceof Abs) {
                return true;
            };
            return false;
        };
    }
};
var eqCommandArcChoice = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Arc0 && y instanceof Arc0) {
                return true;
            };
            if (x instanceof Arc1 && y instanceof Arc1) {
                return true;
            };
            return false;
        };
    }
};
var c = function (ref) {
    return function (x1_) {
        return function (y1_) {
            return function (x2_) {
                return function (y2_) {
                    return function (x_) {
                        return function (y_) {
                            return renderCommand(ref)("c") + (show(x1_) + ("," + (show(y1_) + (" " + (show(x2_) + ("," + (show(y2_) + (" " + (show(x_) + ("," + show(y_)))))))))));
                        };
                    };
                };
            };
        };
    };
};
var a = function (ref) {
    return function (rx_) {
        return function (ry_) {
            return function (rot) {
                return function (arc) {
                    return function (sweep) {
                        return function (x_) {
                            return function (y_) {
                                return renderCommand(ref)("a") + (show(rx_) + (", " + (show(ry_) + (", " + (show(rot) + (" " + (printCommandArcChoice(arc) + (" " + (printCommandSweepChoice(sweep) + (" " + (show(x_) + (" " + show(y_)))))))))))));
                            };
                        };
                    };
                };
            };
        };
    };
};
export {
    Rel,
    Abs,
    Arc0,
    Arc1,
    Sweep0,
    Sweep1,
    toArrayString,
    m,
    l,
    h,
    v,
    c,
    s,
    q,
    t,
    a,
    z,
    eqPathCommand,
    showPathCommand,
    eqCommandPositionReference,
    showCommandPositionReference,
    eqCommandArcChoice,
    showCommandArcChoice,
    eqCommandSweepChoice,
    showCommandSweepChoice
};
